import String from '../../../../assets/Locales/teacher_locales.js';
// String.setLanguage(localStorage.getItem("Language"));
let lang = localStorage.getItem("Language");
//console.log(("lang",lang)
if (lang) {
    //console.log(("lang in if",lang)
    String.setLanguage(localStorage.getItem("Language"));
} else {
    //console.log(("lang in else",lang)
    lang = "ar"
    String.setLanguage("ar");
}
export const Inputs = [
    [
        {
            type: "text",
            label:{ ar:"من فضلك ادخل الكود المرسل اليك عبر البريد الالكتروني", en: "Please enter the code sent to you via e-mail" },
            placeholder: "**********",
            title: { ar: "", en: "" },
            name: "code",
        }
    ]

];